import { Button } from "@humansignal/ui";

/**
 * Project header button for projects that use <Preference>: how each
 * source did. Managers only.
 */
export const PreferenceResultsButton = ({ project, canManage }) => {
  if (!canManage || !project?.id || !/<\s*Preference\b/i.test(project.label_config ?? "")) return null;
  // The dialog is loaded when asked for: it uses the platform's dialog
  // parts, which the package entry must not pull in.
  const open = async () => {
    const { openPreferenceResults } = await import("./Results");
    openPreferenceResults({ project });
  };
  return (
    <Button
      size="small"
      look="outlined"
      onClick={open}
      aria-label="See which options the raters prefer"
      data-testid="preference-results"
      className="lsf-pref-results-button"
    >
      Preference results
    </Button>
  );
};
